module.exports = __webpack_public_path__ + "static/media/white-qr.48dc5565.svg";